/**
 * כש־Customer Vacation Chat פעיל, חישובי LDS ב-SearchContext משתמשים ב־channelType "ai_chat"
 * (אותם channel rules כמו agent_site — ערוץ נעול, ללא override ידני).
 */

/** @type {"agent_site" | "ai_chat"} */
let ldsPackagePricingChannelType = "agent_site";

export function getLdsPackagePricingChannelType() {
  return ldsPackagePricingChannelType;
}

/**
 * @param {unknown} t
 */
export function setLdsPackagePricingChannelType(t) {
  ldsPackagePricingChannelType = t === "ai_chat" ? "ai_chat" : "agent_site";
}
